<template>
  <b-container class="referral-jam-event-page mb-5">
    <div class="d-flex justify-content-center align-items-center my-5" v-if="state === 'LOADING'">
      <b-spinner type="grow" variant="primary"/>
    </div>
    <div class="d-flex justify-content-center align-items-center my-5"  v-else-if="state === 'NOT-FOUND'">
      <p>Event not found.</p>
    </div>
    <b-row v-else-if="event && event.id">
      <b-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3">
        <div class="d-flex flex-row justify-content-start align-items-start my-3 border-bottom pb-3">
          <h2 class="m-0">{{ event.title }}</h2>
        </div>
        <!-- <b-media class="m-3 align-items-center" v-if="event.leaderboard && event.leaderboard.prizes && event.leaderboard.prizes.text">
          <template #aside v-if="event.leaderboard.prizes && event.leaderboard.prizes.first && event.leaderboard.prizes.first.image && typeof event.leaderboard.prizes.first.image.fileLocation === 'string'">
            <b-img v-if="event.leaderboard.prizes.first.image.fileLocation.endsWith('.gif')" class="rounded-circle" height="100" width="100"
              :src="event.leaderboard.prizes.first.image.fileLocation" :alt="event.leaderboard.prizes.first.title || null"/>
            <b-img v-else class="rounded-circle" height="100" width="100"
              :src="event.leaderboard.prizes.first.image.fileLocation | cdn('resize', 256, 256)" :alt="event.leaderboard.prizes.first.title || null"/>
          </template>
          <h3 class="m-0">{{ event.leaderboard.prizes.text }}</h3>
        </b-media> -->
        <rich-text-content v-if="event.welcomeContent" class="my-5" :value="event.welcomeContent"/>
        <div class="d-flex flex-row justify-content-center align-items-center my-3">
          <b-btn class="text-uppercase" :to="{ name: 'EventRoom', params: { eventID } }" variant="primary">Get Started</b-btn>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import EventRoomQuery from '@/graphql/queries/RfjmEventRoom.gql';
import eventsMixin from '@src/mixins/events';
import { RichTextContent } from '@/components/RichTextField';
import { createVueMetaBranding } from '@src/lib/branding';

export default {
  props: {
    eventID: {
      type: String,
      required: true,
    },
  },
  mixins: [ eventsMixin ],
  components: {
    RichTextContent,
  },
  data: () => ({
    state: null,
  }),
  created() {
    this.state = 'LOADING';
  },
  metaInfo() {
    const head = {};

    if (this.event && this.event.id) {
      const { title } = this.event;
      head.title = title;

      if (this.event.branding) {
        const isAdminUI = process.env.VUE_ENV === 'server' ? false : process.env.ADMIN_UI;
        const nonce = process.env.VUE_ENV === 'server' ? (this.$ssrContext.nonce || '') : '';
        createVueMetaBranding.call(this, head, this.event.branding, { isAdminUI, nonce });
      }
    }

    return head;
  },
  apollo: {
    event: {
      query: EventRoomQuery,
      variables() {
        const eventID = this.eventID.split('-').pop();
        return { eventID };
      },
      update(data) {
        const { company } = data || {};
        const { event } = company || {};
        return event;
      },
      result({ loading, data }) {
        if (!loading && data && data.company && data.company.event) {
          if (this.isRecruiterAdmin || this.eventHasStarted) {
            this.state = 'ONLINE';
          } else {
            this.state = 'OFFLINE';
          }

          if (this.eventID !== this.eventHandle) {
            this.$router.replace({
              ...this.$route,
              params: { ...this.$route.params, eventID: this.eventHandle },
            });
          }
        } else if (!loading && data && data.company) {
          this.state = 'NOT-FOUND';
        }

        if ([ 'OFFLINE', 'NOT-FOUND' ].includes(this.state)) {
          this.$router.replace({ ...this.$route, name: 'EventPage' });
        }
      },
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ReferralJam/EventWelcome.vue